// Client-side image compression for staff photo evidence (#95/#99).
// Resizes onto a canvas and steps JPEG quality down until the encoded payload
// fits under maxBytes, so we never POST a multi-MB base64 string.

export function compressImageToDataUrl(source, { maxDim = 1280, maxBytes = 1024 * 1024 } = {}) {
  const sw = source.videoWidth || source.naturalWidth || source.width;
  const sh = source.videoHeight || source.naturalHeight || source.height;
  const scale = Math.min(1, maxDim / Math.max(sw, sh || 1));
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(sw * scale));
  canvas.height = Math.max(1, Math.round(sh * scale));
  const ctx = canvas.getContext("2d");
  ctx.drawImage(source, 0, 0, canvas.width, canvas.height);

  let quality = 0.85;
  let dataUrl = canvas.toDataURL("image/jpeg", quality);
  // base64 expands bytes by ~4/3; trim quality until the encoded string is under the cap.
  while (dataUrl.length * 0.75 > maxBytes && quality > 0.3) {
    quality = Math.round((quality - 0.1) * 100) / 100;
    dataUrl = canvas.toDataURL("image/jpeg", quality);
  }
  return dataUrl;
}

export function fileToCompressedDataUrl(file, opts) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      try {
        resolve(compressImageToDataUrl(img, opts));
      } finally {
        URL.revokeObjectURL(url);
      }
    };
    img.onerror = (err) => {
      URL.revokeObjectURL(url);
      reject(err);
    };
    img.src = url;
  });
}
